<ng-form class="k-form k-form-md" [formGroup]="appRouterData" *ngIf="(sapInitial$|async) as sapInitial">
    <div class="row">
        <div class="form-group col-sm-2 col-md-2 col-lg-2" *ngIf="sapInitial.BodyType !== 'MATRIX'">
            <kendo-label text="Add Pre-Machine" for="PreMachine"><kendo-switch formControlName="PreMachine" #PreMachine
                onLabel="Yes" offLabel="No"
                (valueChange)="getRouters()"></kendo-switch>
            </kendo-label>
        </div>
        <div class="form-group col-sm-2 col-md-2 col-lg-2" *ngIf="sapInitial.BodyType !== 'MATRIX'">
            <kendo-label text="Universal Blank" for="UniversalBlank"><kendo-switch  formControlName="UniversalBlank" #UniversalBlank
                onLabel="Yes" offLabel="No"
                (valueChange)="getRouters()"></kendo-switch>
            </kendo-label>
        </div>
        <div class="form-group col-sm-2 col-md-2 col-lg-2" *ngIf="sapInitial.BodyType !== 'MATRIX'">
            <kendo-label text="AB Coating" for="ABCoating"><kendo-switch formControlName="ABCoating" #ABCoating
                onLabel="Yes" offLabel="No"
                (valueChange)="getRouters()"></kendo-switch>
            </kendo-label>
        </div>
        <div class="form-group col-sm-2 col-md-2 col-lg-2" *ngIf="sapInitial.BodyType !== 'MATRIX'">
            <kendo-label text="Casting" for="Casting"><kendo-switch formControlName="Casting" #Casting
                onLabel="Yes" offLabel="No"
                (valueChange)="getRouters()"></kendo-switch>
            </kendo-label>
        </div>
        <div class="form-group col-sm-2 col-md-2 col-lg-2" *ngIf="sapInitial.BodyType !== 'MATRIX'">
            <kendo-label text="2pc->1pc" for="TwoPieceToOnePiece"><kendo-switch formControlName="TwoPieceToOnePiece" #TwoPieceToOnePiece
                onLabel="Yes" offLabel="No"
                (valueChange)="getRouters()"></kendo-switch>
            </kendo-label>
        </div>
        <div class="form-group col-sm-3 col-md-3 col-lg-2" *ngIf="sapInitial.BodyType !== 'MATRIX'">
            <label class="control-label" for="SteelType">Steel Type:</label>
            <kendo-dropdownlist (valueChange)="getRouters()" formControlName="SteelType" #SteelType [data]="Steeltypeoptions">
            </kendo-dropdownlist>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-sm-12 col-md-4">
            <label class="control-label" for="bitheadrouter">
                Bit Head Router
                <span>
                    <kendo-checkbox id="ManualRouter" name="ManualRouter" [(ngModel)]="ManualRouter">
                    </kendo-checkbox>
                    <label class="control-label" for="ManualRouter">Manual Router Entry</label>
                </span>
            </label>
            <kendo-dropdownlist id="bitheadrouter" name="bitheadrouter" *ngIf="!ManualRouter"
                 [data]="bitHeadRouters">
            </kendo-dropdownlist>
            <input type="text" id="bitheadrouter" name="bitheadrouter" *ngIf="ManualRouter"
                >
        </div>
        <div class="form-group col-sm-3 col-md-3 col-lg-3" *ngIf="sapInitial.Sleeve">
            <label class="control-label" for="sleeverouter">Sleeve Router</label>
            <kendo-dropdownlist id="sleevereouters" name="sleevereouters"
                 [data]="sleeveRouters">
            </kendo-dropdownlist>
        </div>
    </div>
    <div class="row" *ngIf="sapInitial.BodyType === 'MATRIX'">
        <div class="form-group col-sm-6 col-md-4 col-lg-3">
            <kendo-label text="Add Milled Blank Router">
                <kendo-switch
                     onLabel="Yes"
                    offLabel="No"></kendo-switch>
            </kendo-label>
        </div>
    </div>
</ng-form>